import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ReviewsModal from '@op/components/ReviewsModal';
import ChannelLabel from '@op/components/ChannelLabel';
import { getFeedsContentText } from '@op/utils/languageValue';
import CardCommon from '@op/components/CardCommon';
import { openWindowUrl } from '@op/utils/url';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import '@op/assets/scss/pages/summary/components/contextComponent.scss';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
export default function ContextComponent({
  list,
  topList = [],
  languageType,
  renderFunc = (value: string) => value,
}: any) {
  const { formatMessage } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({});
  const open = () => setVisible(true);
  const close = () => {
    setVisible(false);
    setData({});
  };

  const isEmpty = list?.length === 0 && topList?.length === 0;

  const renderCommentItem = (e: any) => (
    <div
      className="dbo-context-component hot-event-box"
      key={e.comment_uin || e.comment_id}
    >
      <div className="dbo-context-component-flex">
        <ChannelLabel
          className="dbo-context-component-icon"
          channel_name={e.channel_name}
          showText={false}
        ></ChannelLabel>
        <div
          className="dbo-context-component-text"
          onClick={() => {
            buriedBtnPoint('HC_feed');
            setData(e);
            open();
          }}
        >
          <span>
            {renderFunc(getFeedsContentText(e, languageType), e)}
          </span>
        </div>
      </div>
      {e?.content_url && (
        <span
          onClick={(event) => {
            event.stopPropagation();
            openWindowUrl(e?.content_url);
          }}
        >
          <SvgIcon
            type="other-share-icon"
            className="dbo-context-component-link"
          />
        </span>
      )}
    </div>
  );

  return (
    <CardCommon
      contentCard
      empty={isEmpty}
      emptyHeight={400}
    >
      <>
        {topList?.length > 0 && (
          <CardCommon
            contentCard
            title={
              <div className="list-header-tips">
                {formatMessage({ id: 'Representative Reviews' })}
              </div>
            }
          >
            {topList.map((e: any) => renderCommentItem(e))}
          </CardCommon>
        )}
        {
          list?.length > 0 && (
            <CardCommon
              contentCard
              title={
                <div className="list-header-tips">
                  {formatMessage({
                    id: 'The following reviews are sorted by engagements',
                  })}
                </div>
              }
            >
              {list.map((e: any) => renderCommentItem(e))}
            </CardCommon>
          )
        }
        <ReviewsModal
          language={languageType}
          data={data}
          // content={renderFunc(getFeedsContentText(data, languageType), data)}
          visible={visible}
          close={close}
        />
      </>
    </CardCommon>
  );
}
